var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRelationshipMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 15.75V12h3l3-3V6.6a2.252 2.252 0 01-1.088-.816A2.143 2.143 0 016.75 4.5c0-.625.219-1.156.656-1.594A2.17 2.17 0 019 2.25a2.17 2.17 0 011.594.656c.437.438.656.969.656 1.594 0 .475-.137.903-.412 1.284A2.252 2.252 0 019.75 6.6V9l3 3h3v3.75H12v-2.287l-3-3-3 3v2.287H2.25z",
    fill: "#687587"
  })));
}
export default SvgRelationshipMap;